import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { CustomersService } from '@pages/customers/customers.service';
import { IStats } from '@shared/interfaces/stats.interface';
import { EMPTY, MonoTypeOperatorFunction, Observable, pipe } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

interface ICustomersKpiCardsState {
  stats: IStats[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: ICustomersKpiCardsState = {
  error: null,
  loading: false,
  stats: null,
};

@Injectable()
export class CustomersKpiCardsStore extends ComponentStore<ICustomersKpiCardsState> {
  public readonly stats$ = this.selectSignal((state: ICustomersKpiCardsState) => state.stats);
  public readonly loading$ = this.selectSignal((state: ICustomersKpiCardsState) => state.loading);
  public readonly error$ = this.selectSignal((state: ICustomersKpiCardsState) => state.error);

  private readonly handleError = (errorMessage: string): MonoTypeOperatorFunction<unknown> =>
    pipe(
      catchError(() => {
        this.patchState({
          error: errorMessage,
          loading: false,
        });

        return EMPTY;
      }),
    );

  public readonly fetchCustomersStats = this.effect((trigger$: Observable<void>) => {
    return trigger$.pipe(
      tap(() => this.patchState({ error: null, loading: true })),
      switchMap(() =>
        this.customersService.getCustomersStats().pipe(
          tap((stats) => {
            this.patchState({ loading: false, stats });
          }),
          this.handleError('Failed to load customers stats'),
        ),
      ),
    );
  });

  constructor(private readonly customersService: CustomersService) {
    super(initialState);
  }
}
